import React, { useEffect, useState } from 'react';
import "../../styles/PopularCourses.css";
import CourseCard from '../cards/CourseCard';
import { getCourses } from '../../api/contentApi';
import ApiContentState from '../common/ApiContentState';

function PopularCourses({ onSelectCourse }) {
  const [apiCourses, setApiCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    getCourses()
      .then((items) => setApiCourses(Array.isArray(items) ? items : []))
      .catch((error) => {
        console.error('Unable to load popular courses:', error);
        setLoadError("Unable to load courses.");
      })
      .finally(() => setIsLoading(false));
  }, []);

  const courses = apiCourses.slice(0, 4).map((course) => ({
        id: course.id,
        courseType: course.courseType,
        badge: course.courseType || 'Creator Program',
        title: course.title,
        desc1: course.details || 'Practical skills for modern creators',
        desc2: course.category || 'Creator education',
        instructor: course.instructor || 'Creator Dost Mentor',
        rating: course.reviewCount
          ? `${Number(course.rating || 0).toFixed(1)} (${course.reviewCount})`
          : 'No reviews',
        price: course.totalPrice || course.price || 'View details',
        originalPrice: course.price || '',
        imageUrl: course.imageUrl,
        avatarUrl: course.instructorAvatar,
        videoUrl: course.videoUrl,
      }));

  return (
    <section className="homepage-section">
      <div className="section-flex-header">
        <h2>Our <span>Popular </span>Courses</h2>
        <a href="#all" className="global-redirect-link view-all-desktop">View All Courses ➔</a>
      </div>
      
      <div className="courses-carousel-viewport">
        {isLoading || loadError || courses.length === 0 ? (
          <ApiContentState
            loading={isLoading}
            error={loadError}
            emptyMessage="No courses are available right now."
          />
        ) : courses.map(course => (
          <CourseCard 
            key={course.id} 
            courseData={course}
            onSelectCourse={onSelectCourse}
          />
        ))}
      </div>

      <div className="view-all-mobile-wrapper">
        <a href="#all" className="global-redirect-link view-all-mobile">View All Courses ➔</a>
      </div>
    </section>
  );
}

export default PopularCourses;